import { ReactNode } from 'react';
import { Checkbox, FormControlLabel, Radio, TextField } from '@mui/material';
import { CourseMappingDropdownOption } from './courseMappingDropdownOptions';
import { CourseMappingFilterField, CourseMappingFilterValue } from './courseMappingFilterFields';
import CourseMappingSelectTag from './CourseMappingSelectTag';

interface CourseMappingFilterValuePickerProps {
  field: CourseMappingFilterField;
  value: CourseMappingFilterValue;
  options: CourseMappingDropdownOption[];
  onChange: (value: CourseMappingFilterValue) => void;
}

const CourseMappingFilterValuePicker = ({ field, value, options, onChange }: CourseMappingFilterValuePickerProps) => {
  if (field.control === 'text' || field.control === 'number') {
    return (
      <div className="course-mapping-filter-value-picker">
        <p className="course-mapping-filter-value-picker-label">{field.label} contains</p>
        <TextField
          type={field.control === 'number' ? 'number' : 'text'}
          size="small"
          autoFocus
          fullWidth
          placeholder={`${field.label}…`}
          value={value as string}
          onChange={(event) => onChange(event.target.value)}
        />
      </div>
    );
  }

  const isMulti = field.control === 'multi';
  const selectedValues = isMulti ? (value as string[]) : [value as string];

  const renderOptionLabel = (label: string): ReactNode =>
    field.key === 'subjectArea' ? <CourseMappingSelectTag label={label} columnKey="subjectArea" /> : label;

  const handleToggle = (optionValue: string) => {
    if (isMulti) {
      const current = value as string[];
      const next = current.includes(optionValue)
        ? current.filter((entry) => entry !== optionValue)
        : [...current, optionValue];
      onChange(next);
      return;
    }

    onChange(value === optionValue ? '' : optionValue);
  };

  return (
    <div className="course-mapping-filter-value-picker">
      <p className="course-mapping-filter-value-picker-label">{field.label} is</p>
      <ul className="course-mapping-filter-value-picker-list">
        {options.length === 0 ? (
          <li className="course-mapping-filter-value-picker-empty">No options available</li>
        ) : (
          options.map((option) => {
            const checked = selectedValues.includes(option.value);

            return (
              <li key={option.value}>
                <FormControlLabel
                  className="course-mapping-filter-value-picker-item"
                  control={
                    isMulti ? (
                      <Checkbox size="small" checked={checked} onChange={() => handleToggle(option.value)} />
                    ) : (
                      <Radio size="small" checked={checked} onChange={() => handleToggle(option.value)} />
                    )
                  }
                  label={renderOptionLabel(option.label)}
                />
              </li>
            );
          })
        )}
      </ul>
    </div>
  );
};

export default CourseMappingFilterValuePicker;
